import { DictionaryWithMappingType } from '../../../../types/dictionary';
import { getDictionaryMappingsByPatternId } from './mapping/read';

// パターンに紐づく辞書（本体＋マッピング）を取得する（OCR 結果画面のあいまい変換用）。
// dictionary_mappings の collectionGroup クエリ経由で取得する。
export const getDictionariesByPatternId = async (
  companyId: string,
  patternId: string,
): Promise<DictionaryWithMappingType[]> => {
  return getDictionaryMappingsByPatternId(companyId, patternId);
};
